<template>
  <div class="bg-secondary d-none d-lg-block">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 my-3">
          <a href="https://tw.nextapple.com" target="_blank">
            <img class="nextapple-logo" src="https://static.nextapple.tw/web/layout/img/logo1201.svg" alt="壹蘋新聞網">
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-primary">
    <div class="container">
      <div v-if="$route.path !== '/data-safety'" class="row justify-content-center">
        <div class="col-md-10 d-flex">
          <router-link class="router-link me-4" to="/">投訴爆料</router-link>
          <!-- <router-link class="router-link" to="/ugc">全民投稿</router-link><br> -->
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import { useRecaptchaProvider } from 'vue-recaptcha'

useRecaptchaProvider()
</script>

<style lang="scss" scoped>
.nextapple-logo {
  max-width: 200px;
}

.router-link {
  color: white;
  // line-height: 50px;
  // box-sizing: content-box;
  border-top: 5px solid transparent;
  font-weight: bold;
}

.router-link-active {
  border-bottom: 5px solid #FFB300;
}

</style>